// Dropbox's Chooser script used to be a <script> tag in public/index.html, which meant
// every visitor fetched a third-party script from dropbox.com on every page load —
// including logged-out visitors sitting on the login page, who can't reach a Chooser
// button at all. The Chooser only ever renders inside authenticated modals (see
// DropboxChooserButton's consumers), so it is loaded on demand instead.
//
// This is also what keeps DropWyrm out of cookie-banner territory: no non-essential
// third-party script runs until the user actively opens a picker. The "Cookies and
// Similar Technologies" section of public/content/DropWyrmVTT-Privacy-Policy_1.0.md
// says as much, so don't move this back into index.html without revisiting that text.

const APP_KEY = process.env.REACT_APP_DROPBOX_APP_KEY || 'fyeg01h837hqo5q';
const SCRIPT_ID = 'dropboxjs';

// Module-level so concurrent callers (several modals can mount at once) share one
// injection rather than racing to append duplicate tags.
let pending = null;

export default function loadDropboxChooser() {
    if (window.Dropbox) return Promise.resolve(window.Dropbox);
    if (pending) return pending;

    pending = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.src = 'https://www.dropbox.com/static/api/2/dropins.js';
        script.setAttribute('data-app-key', APP_KEY);
        script.async = true;
        script.onload = () => {
            if (window.Dropbox) resolve(window.Dropbox);
            else reject(new Error('Dropbox Chooser loaded but did not initialize.'));
        };
        script.onerror = () => reject(new Error('Failed to load the Dropbox Chooser.'));
        document.head.appendChild(script);
    });

    // A failed load must not poison every later attempt — drop the cached promise so a
    // retry (user clicks the button again) gets a fresh script tag.
    pending.catch(() => {
        pending = null;
        document.getElementById(SCRIPT_ID)?.remove();
    });

    return pending;
}
